import React from 'react';
import { useAuth } from '../lib/auth';
import { Navigate } from 'react-router-dom';

export default function ProtectedRoute({ children, requireAdmin = false }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen grid place-items-center">
        <div className="dot-loader"><span /><span /><span /></div>
      </div>
    );
  }
  if (!user) return <Navigate to="/" replace />;
  if (requireAdmin && user.role !== 'admin' && user.role !== 'super_admin') return <Navigate to="/dashboard" replace />;
  return children;
}
